import { NextSeo } from 'next-seo';
import React from 'react';
import Link from 'components/links/Link';
import Footer from 'components/Footer';

function WinnerPage() {
    return (
        <>
            <NextSeo title="Zmagovalec nagradnega izbora" />

            <div className="single-page page-finalist lg:pt-12 pt-6">
                <div className="container">
                    <div className="flex flex-col md:flex-row gap-8">
                        <div className="image relative w-[100%]">
                            <img
                                src="/images/foto-izbor/zmagovalec-image.jpg"
                                alt="Orlovo gnezdo - Matic Mislej"
                                width="100%"
                                height={479}
                                className="object-cover rounded-2xl"
                            />
                            <div className="absolute -bottom-10 -right-2">
                                <img src="/images/foto-izbor/badge.svg" alt="" width={80} height={120} />
                            </div>
                        </div>
                        <div className="content">
                            <h1 className="normal-case">Zmagovalec nagradnega fotografskega izbora lepot Slovenije</h1>
                            <p className="mt-2">
                                Med 40 čudovitimi finalisti ste izbrali fotografijo Bohinjskega Jezera, avtorja Štefana
                                Kovača.
                            </p>

                            <div className="my-4">
                                <h3 className="text-brand">Štefan Kovač</h3>
                                <Link to="/ideja/orlovo-gnezdo-veli-badin" styles="underline">
                                    Bohinjsko jezero (plaža na J strani)
                                </Link>
                            </div>
                            <ul>
                                <li className="font-bold text-xl">
                                    Vsi glasovi: <span className="text-brand">1180</span>
                                </li>
                                <li>
                                    Glasovi na spletni strani: <span className="text-brand">4</span>
                                </li>
                                <li>
                                    Facebook glasovi: <span className="text-brand">17</span>
                                </li>
                                <li>
                                    Instagram glasovi: <span className="text-brand">1159</span>
                                </li>
                            </ul>
                        </div>
                    </div>
                </div>
                <div className="container my-20">
                    <div className="flex">
                        <div>
                            <h2 className="text-brand mb-4">Nagrada</h2>
                            <p>
                                Zmagovalec prejme Nikon Z30, ki ga kot partnerja projekta poklanjata Big Bang in Nikon.
                                <br />
                                <strong>Iskrene čestitke!</strong>
                            </p>
                            <div className="mt-4">
                                <p>
                                    <small>PARTNERJA</small>
                                </p>
                                <div className="flex items-center gap-3">
                                    <Link to="https://bigbang.si" target="_blank">
                                        <img
                                            src="/images/foto-izbor/bigbang-logo.svg"
                                            alt="Big bang Slovenija"
                                            className="inline-block h-8"
                                        />
                                    </Link>
                                    <Link to="https://www.nikon.si/sl_SI" target="_blank">
                                        <img
                                            src="/images/foto-izbor/logo-nikon.svg"
                                            alt="Nikon"
                                            className="inline-block h-8"
                                        />
                                    </Link>
                                </div>
                            </div>
                        </div>
                        <div>
                            <img src="/images/foto-izbor/nagrada-nikon.png" alt="" width={515} height={374} />
                        </div>
                    </div>
                </div>
                <section id="shirts">
                    <div className="container">
                        <div className="flex gap-4 justify-center">
                            <img src="/images/icons/puscica-dol.svg" alt="" className="hidden md:block" />
                            <h2 className="uppercase text-brand">Prejemniki KZV majice</h2>
                            <img src="/images/icons/puscica-dol.svg" alt="" className="hidden md:block" />
                        </div>
                        <p className="text-center max-w-md mx-auto mt-3">
                            Izmed vseh, ki ste sodelovali v nagradnem fotografskem izboru lepot Slovenije, smo izžrebali
                            30 dobitnikov Kam za vikend majic. Iskrene čestitke!
                        </p>
                        <div className="mt-6 lg:mt-8 flex md:flex-row flex-col md:gap-20 justify-center items-center">
                            <img
                                src="/images/foto-izbor/majica.png"
                                alt="Kam za vikend majica"
                                width={567}
                                height={423}
                            />
                            <ol className="list-decimal">
                                <li>Monika M.</li>
                                <li>Polona N.</li>
                                <li>Maša V.</li>
                                <li>Tjaša B.</li>
                                <li>Lea M.</li>
                                <li>Metka Z.</li>
                                <li>Andreja K. D.</li>
                                <li>Damjan Z.</li>
                                <li>Aušra V.</li>
                                <li>Alenka G.</li>
                                <li>Vlasta P.</li>
                                <li>Mark P.</li>
                                <li>Tomaz J.</li>
                                <li>Jože R.</li>
                                <li>Larisa A.</li>
                                <li>Marta B.</li>
                            </ol>
                            <ol className="list-decimal" start={17}>
                                <li>Štefan Č.</li>
                                <li>Maja J.</li>
                                <li>VALENTINA A.</li>
                                <li>Primož S.</li>
                                <li>Mateja A.</li>
                                <li>France R.</li>
                                <li>Jaka K.</li>
                                <li>Ken C.</li>
                                <li>Tanja J.</li>
                                <li>Matej E.</li>
                                <li>Ines P.</li>
                                <li>Natasa K.</li>
                                <li>Simona K.</li>
                                <li>Tine S.</li>
                            </ol>
                        </div>
                    </div>
                </section>
                <Footer />
            </div>
        </>
    );
}

export default WinnerPage;
